"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable */
var _default = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
  fillRule: "evenodd",
  d: "M11.6001 2.3999c-1.1046 0-2 .8954-2 2v10.4a1.994 1.994 0 00.4261 1.2342c.3662.4663.935.7658 1.5739.7658h10.4c1.1046 0 2-.8955 2-2v-.8c0-1.1046-.8954-2-2-2h-7.6v-7.6c0-1.1046-.8954-2-2-2h-.8z",
  clipRule: "evenodd"
})), 'AwayIcon');
/* eslint-enable */


exports["default"] = _default;